export const strings = {
    signin: 'Sign in to PMPP UI',
    logout: 'Logout',
    ok: 'Ok',
    cancel: 'Cancel',

    pmpp: 'PMPP',

    action_browse: "Browse files",
    action_submit: "Submit",
    action_show_results: 'Show results',
    action_download_results: 'Download results',
    action_delete: 'Delete',
    action_cancel: 'Cancel',
    action_close: 'Close',

    file_selector_text: 'Drag and drop a .csv or a .sdf file',
    or: 'or',
    mode: 'mode',

    only_csv_file_allowed: "Only .csv and .sdf file formats are allowed.",

    prediction_job_name: 'Prediction job name',
    smiles_column: 'SMILES column',
    properties_predictions: 'Properties predictions',
    
    request_error: 'Something went wrong with your request',

    name: 'Name',
    state: 'State',
    creation_date: 'Creation date',
    actions: 'Actions',

    new_prediction: 'New prediction',
    prediction_jobs: 'Prediction jobs',

    prediction_job_created: 'Prediction job created',
    prediction_job_successfully_created: 'Prediction job successfully created!',

    prediction_job_description: 'Prediction job description',

    training_date: 'Training date',
    kendall_tau: 'Kendall tau',
    pearson_r: 'Pearson correlation',
    spearman_r: 'Spearman correlation',

    models_information: 'Models information',
    results: 'Results',
    download_csv: 'Download CSV',
    csv_format: 'CSV format',
    sdf_format: 'SDF format',

    dialog_prediction_job_delete_title: 'Delete Prediction job',
    dialog_prediction_job_delete_body: 'Are you sure you want to delete this Prediction job?',

    invalid_pasted_csv: 'Pasted string contains an invalid CSV file.'

}